module.exports = __webpack_public_path__ + "static/media/8.9123e769.jpg";